import request from './request';
import deserialize from './deserialize';

export type StampCampaign = {
  id: string;
  details: string;
  status: 'draft' | 'active';
  maxStamps: number;
  description: string;
  issuedNewStampCards: boolean;
  multipleCards: boolean;
  notification: string;
  storeStampLimit: number;
  type: string;
  issueCardNewMember: boolean;
  name: string;
  reissueWelcomeRewards: boolean;
  slotNumber: number;
};

export function get(companyId: string, stampCampaignId: string) {
  return request<StampCampaign>({
    url: `/v1/companies/${companyId}/stamp_campaign/${stampCampaignId}`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export type Milestone = {
  id: string;
  threshold: number;
  validityPeriodDays: number;
  reward: {
    type: 'rewards';
    id: string;
  };
  stampCampaign: {
    type: 'stamp_campaigns';
    id: string;
  };
  rewardTemplate: {
    type: 'reward_templates';
    id: string;
  };
};

export function listMilestones(companyId: string, stampCampaignId: string) {
  return request<Milestone[]>({
    url: `/v1/companies/${companyId}/stamp_campaigns/${stampCampaignId}/milestones`,
    method: 'GET',
    transformResponse: deserialize,
  });
}

export function listActive(companyId: string) {
  return request<StampCampaign[]>({
    url: `/v1/companies/${companyId}/stamp_campaigns?sort=desc-slotNumber&filter[status][eq]=active`,
    method: 'GET',
    transformResponse: deserialize,
  });
}
